"use client";

import "./PhoneMode.css";

export default function PhoneMode() {

	return (
		<div className="phone-mode">
			<h1>
				ekaterina potapova
			</h1>
			<div className="heading-underline"></div>

			<p>ERROR</p>
			<img src="/Img/Pigeons/error_pigeon.png" className="logo" alt="logo" />
			<p>Please open it from your computer browser!</p>
			<p>Phone version still in development!</p>
		</div>
	);
}